import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getCountryAll = (_params, onSuccess, onError) => {
    // _params.orders = 'country_name:asc';
    const response = axios.get('v1/admin/country', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getCountryById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/country/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createCountry = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/country`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateCountry = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/country/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteCountry = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/country/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteCountry = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/country/${id}`);
    return handleResponse(response, onSuccess, onError);
};